// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"a1d2c803","787":"4638d6c4"}[chunkId] + ".chunk.js";
};